export default __webpack_public_path__ + "f1065362a669c66b78291fc8dd35ead4.webp";